var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22949 15.9056C4.22949 13.1963 6.42581 11 9.1351 11H25.845C28.5543 11 30.7506 13.1963 30.7506 15.9056C30.7506 18.6149 28.5543 20.8112 25.845 20.8112H9.1351C6.42581 20.8112 4.22949 18.6149 4.22949 15.9056Z",
    fill: "#FF6262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9805 28.5345C16.9805 25.8252 19.1768 23.6289 21.8861 23.6289H35.5359C38.2452 23.6289 40.4415 25.8252 40.4415 28.5345C40.4415 31.2438 38.2452 33.4401 35.5359 33.4401H21.8861C19.1768 33.4401 16.9805 31.2438 16.9805 28.5345Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74023 28.5345C4.74023 25.8252 6.93655 23.6289 9.64584 23.6289H10.0351C12.7444 23.6289 14.9407 25.8252 14.9407 28.5345C14.9407 31.2438 12.7444 33.4401 10.0351 33.4401H9.64584C6.93655 33.4401 4.74023 31.2438 4.74023 28.5345Z",
    fill: "#FF6262"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLogo);
export default __webpack_public_path__ + "static/media/img_logo.1ae2abf0ab966dcb149e99061154c2eb.svg";
export { ForwardRef as ReactComponent };